import React, { useState, useEffect } from 'react';
import { 
    Container,
    CardGroup,
    Card,
    CardContent,
    CardHeader,
    CardMeta,
    CardDescription,
    Image,
    Icon
} from 'semantic-ui-react';

function Movies({ movies, loadAll }) {
    useEffect(() => {
        loadAll();
    }, []);

    return (
        <Container>
            <h1>Movies</h1>
            <CardGroup style={{ marginTop: '1em' }}>
                {(movies || []).map((movie) => (
                    <Card key={movie.id.toString()}>
                        <Image
                            src={movie.poster}
                            wrapped
                            ui={false}
                        />
                        <CardContent>
                            <CardHeader>{movie.title}</CardHeader>
                            <CardMeta>
                                <span className='date'>{movie.released}</span>
                            </CardMeta>
                            <CardDescription>
                                {movie.genre}
                            </CardDescription>
                        </CardContent>
                        <CardContent extra>
                            <a>
                                <Icon name='user' />
                                {movie.director}
                            </a>
                        </CardContent>
                    </Card>
                ))}
            </CardGroup>
        </Container>
    );
}

export default Movies;
